export default {
  showLogoutModal: false,
  showAuthorizationModal: false,
  isAuthorized: false,
  merchantAccess: false,
  merchantPhoneNumber: null,
  evtSelectRowDropDownStateValue: false
}
